import { jsx as _jsx } from "react/jsx-runtime";
import { BaseMessageCaption } from './BaseMessageCaption';
import { getMessage } from './MESSAGE';
import { Animation } from './Animation';
import { getColorTheme } from '../blob-messaging/blob/blobUtils';
import { BlobKey } from '../blob-messaging/blob/BlobKey';
import { BlobConfig } from '../blob-messaging/blob/BlobConfig';
import { Blobs } from '../blob-messaging/blob/Blobs';

const MessageAnimation = ({
  messageKey
}) => {
  const {
    imageUrl,
    renderBlob = false,
    colorThemeOption,
    loop = false
  } = getMessage(messageKey);
  const blobConfig = BlobConfig[BlobKey.ImageBlob];
  const {
    configColorThemeOption
  } = blobConfig;
  const colorTheme = colorThemeOption || configColorThemeOption;
  return /*#__PURE__*/_jsx(BaseMessageCaption, {
    className: "MessageAnimation",
    messageKey: messageKey,
    children: renderBlob ? /*#__PURE__*/_jsx(Blobs, {
      colorTheme: getColorTheme(colorTheme),
      isVideo: true,
      messageKey: messageKey,
      children: /*#__PURE__*/_jsx(Animation, {
        colorThemeOption: colorThemeOption,
        imageUrl: imageUrl,
        loop: loop,
        renderBlob: renderBlob
      })
    }) : /*#__PURE__*/_jsx(Animation, {
      imageUrl: imageUrl
    })
  });
};

export default MessageAnimation;